class PhrasesService {
    constructor() {
        this.phrases = {};

        if (!window._data.phrases) {
            return;
        }

        for (var i = 0; i < window._data.phrases.length; i++) {
            var phrase = window._data.phrases[i];
            this.phrases[phrase.T] = phrase.V;
        }
    }

    getPhrase(title) {
        if (!this.phrases[title]) {
            return title;
        }

        return this.phrases[title];
    }
}

PhrasesService.shared = new PhrasesService();
Vue.component('addresses', {
        props: {
        },
        data: function () {
            return {
                cities: [],
                addresses: [],
                addAddressData: {
                    city: null,
                    address: null,
                    additionalInfo: null
                },
                addAddressSettings: {
                    succeeded: null,
                    sendingData: false,
                    resultMessage: '',
                },
                phrases: {
                    step1sidebarcontent: PhrasesService.shared.getPhrase('cart_step1sidebarcontent'),
                    step2shippingcontent: PhrasesService.shared.getPhrase('cart_step2shippingcontent'),
                    step2shopcontent: PhrasesService.shared.getPhrase('cart_step2shopcontent'),
                    step3sidebarcontent: PhrasesService.shared.getPhrase('cart_step3sidebarcontent'),
                },
            };
        },
        methods: {
            getAddresses() {
                var _this = this;

                //if (_this.settings.sendingData) { return; }
                _this.addresses = [];
                //_this.settings.sendingData = true;
                var endpointUrl = window._data.cartApiUrl + 'getaddresses';
                axios.post(endpointUrl,
                    {
                        langAbbr: window._data.languageAbbr
                    }).then(function (response) {
                        if (response.data.succeeded) {
                            _this.addresses = response.data.data.addresses;
                            _this.selectAddress(_this.addresses[0]);
                        }
                        //_this.settings.sendingData = false;
                    }).catch(function (e) {
                        //_this.settings.sendingData = false;
                    }).finally(function (e) {
                        //_this.settings.sendingData = false;
                    });
            },
            getCities() {
                var _this = this;
                if (_this.cities.length > 0) {
                    return;
                }
                /*  if (_this.settings.sendingData) { return; }*/

                //_this.settings.sendingData = true;
                var endpointUrl = window._data.cartApiUrl + 'getcities';
                axios.post(endpointUrl,
                    {
                        langAbbr: window._data.languageAbbr
                    }).then(function (response) {
                        if (response.data.succeeded) {
                            _this.cities = response.data.data.cities;
                            //_this.addressData.city = _this.cities[0].id;
                        }
                        //_this.settings.sendingData = false;
                    }).catch(function (e) {
                        //_this.settings.sendingData = false;
                    }).finally(function (e) {
                        //_this.settings.sendingData = false;
                    });
            },
        },
        mounted() {
            var _this = this;

            this.getCities();
            this.getAddresses(true, false);
        },
        computed: {

        }
    ,
template: `
    <div class="">
        <div class="row">
            <div class="col-lg-4" v-for="(address, index) in addresses">
                <div class="card card-dashboard">
                    <div class="card-body">
                        <p>
                            {{address.city.title}}<br>
                            {{address.street}}<br>
                            {{address.comment}}<br>
                            <a href="#">რედაქტირება <i class="icon-edit"></i></a><br />
                            <a href="#">წაშლა <i class="icon-trash"></i></a>
                        </p>
                    </div>
                </div>
            </div>

            <div class="col-lg-4">
                <div class="card card-dashboard">
                    <div class="card-body">
                        <h3 class="card-title">ახალი მისამართის დამატება</h3>

                        <p>
                            &nbsp;
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
`
});
Vue.component('cart', {
        props: {
            isProfileCompleted: Boolean,
            isAuthorized: Boolean,
            isPhysical: Boolean,
            userInfo: Object
        },
        data: function () {
            return {
                cartItems: [],
                cities: [],
                addresses: [],
                addAddressData: {
                    city: null,
                    address: null,
                    additionalInfo: null
                },
                addAddressSettings: {
                    succeeded: null,
                    sendingData: false,
                    resultMessage: '',
                },
                selectedOptions: {
                    selectedAddress: null,
                    selectedDeliveryOption: 0,
                    selectedPaymentMethod: 0
                },
                shipping: {
                    fee: 0,
                    days: '',
                },
                checkoutSettings: {
                    succeeded: null,
                    sendingData: false,
                    resultMessage: '',
                },
                settings: {
                    sendingData: false,
                    resultMessage: '',
                    submitted: false,
                    isAllProductsFromLocalWarehouse: false
                },
                phrases: {
                    empty: PhrasesService.shared.getPhrase('cart_empty'),
                    tableproduct: PhrasesService.shared.getPhrase('cart_tableproduct'),
                    tableprice: PhrasesService.shared.getPhrase('cart_tableprice'),
                    tablequantity: PhrasesService.shared.getPhrase('cart_tablequantity'),
                    tablesum: PhrasesService.shared.getPhrase('cart_tablesum'),
                    addresscity: PhrasesService.shared.getPhrase('cart_addresscity'),
                    addressstreet: PhrasesService.shared.getPhrase('cart_addressstreet'),
                    addressadditionalinfo: PhrasesService.shared.getPhrase('cart_addressadditionalinfo'),
                    addressaddbutton: PhrasesService.shared.getPhrase('cart_addressaddbutton'),
                    addresswaitbutton: PhrasesService.shared.getPhrase('cart_addresswaitbutton'),

                    paymentmethod_banktransfer: PhrasesService.shared.getPhrase('cart_paymentmethod-banktransfer'),
                    paymentmethod_banktransferdescription: PhrasesService.shared.getPhrase('cart_paymentmethod-banktransferdescription'),
                    paymentmethod_pos: PhrasesService.shared.getPhrase('cart_paymentmethod-pos'),
                    paymentmethod_posdescription: PhrasesService.shared.getPhrase('cart_paymentmethod-posdescription'),
                    paymentmethod_tbcinstallment: PhrasesService.shared.getPhrase('cart_paymentmethod-tbcinstallment'),
                    paymentmethod_tbcinstallmentdescription: PhrasesService.shared.getPhrase('cart_paymentmethod-tbcinstallmentdescription'),
                    paymentmethod_tbccard: PhrasesService.shared.getPhrase('cart_paymentmethod-tbccard'),
                    paymentmethod_tbccarddescription: PhrasesService.shared.getPhrase('cart_paymentmethod-tbccarddescription'),
                    selectpaymentmethod: PhrasesService.shared.getPhrase('cart_selectpaymentmethod'),
                    deliverymethod_takeaway: PhrasesService.shared.getPhrase('cart_deliverymethod-takeaway'),
                    deliverymethod_takeawaydescription: PhrasesService.shared.getPhrase('cart_deliverymethod-takeawaydescription'),
                    deliverymethod_courier: PhrasesService.shared.getPhrase('cart_deliverymethod-courier'),
                    cart_selectdeliverymethod: PhrasesService.shared.getPhrase('cart_selectdeliverymethod'),
                    cart_addaddress: PhrasesService.shared.getPhrase('cart_addaddress'),
                    cart_sumproducts: PhrasesService.shared.getPhrase('cart_sumproducts'),
                    cart_sumweight: PhrasesService.shared.getPhrase('cart_sumweight'),
                    cart_shipping: PhrasesService.shared.getPhrase('cart_shipping'),
                    cart_sum: PhrasesService.shared.getPhrase('cart_sum'),
                    cart_processcheckout: PhrasesService.shared.getPhrase('cart_processcheckout'),
                    cart_processreserve: PhrasesService.shared.getPhrase('cart_processreserve'),
                    cart_processing: PhrasesService.shared.getPhrase('cart_processing'),
                    cart_returntoshop: PhrasesService.shared.getPhrase('cart_returntoshop'),
                    paymentmethod_boginstallment: PhrasesService.shared.getPhrase('cart_paymentmethod_boginstallment'),
                    paymentmethod_boginstallmentdescription: PhrasesService.shared.getPhrase('cart_paymentmethod_boginstallmentdescription'),
                },
            };
        },
        methods: {
            gotoHome() {
                window.open(window._data.homeUrl, "_self");
            },
            openProductUrl(url) {
                window.open(url, "_self");
            },
            increaseCartItemQuantity(cartItem) {
                this.updateCartItem(cartItem, parseInt(cartItem.quantity) + 1);
            },
            decreaseCartItemQuantity(cartItem) {
                this.updateCartItem(cartItem, parseInt(cartItem.quantity) - 1);
            },
            deleteCartItem(cartItem) {
                var _this = this;
                if (_this.settings.sendingData) { return; }

                _this.settings.sendingData = true;
                var endpointUrl = window._data.cartApiUrl + 'remove';
                axios.post(endpointUrl,
                    {
                        productId: cartItem.product.id,
                    }).then(function (response) {
                        _this.settings.sendingData = false;
                        if (response.data.succeeded) {
                            _this.getCartItems();
                        }
                    }).catch(function (e) {
                        _this.settings.sendingData = false;
                    }).finally(function (e) {
                        _this.settings.sendingData = false;
                    });
            },
            getCities() {
                var _this = this;
                if (_this.cities.length > 0) {
                    return;
                }
                /*  if (_this.settings.sendingData) { return; }*/

                //_this.settings.sendingData = true;
                var endpointUrl = window._data.cartApiUrl + 'getcities';
                axios.post(endpointUrl,
                    {
                        langAbbr: window._data.languageAbbr
                    }).then(function (response) {
                        if (response.data.succeeded) {
                            _this.cities = response.data.data.cities;
                            //_this.addressData.city = _this.cities[0].id;
                        }
                        //_this.settings.sendingData = false;
                    }).catch(function (e) {
                        //_this.settings.sendingData = false;
                    }).finally(function (e) {
                        //_this.settings.sendingData = false;
                    });
            },
            getAddresses() {
                var _this = this;

                //if (_this.settings.sendingData) { return; }
                _this.addresses = [];
                //_this.settings.sendingData = true;
                var endpointUrl = window._data.cartApiUrl + 'getaddresses';
                axios.post(endpointUrl,
                    {
                        langAbbr: window._data.languageAbbr
                    }).then(function (response) {
                        if (response.data.succeeded) {
                            _this.addresses = response.data.data.addresses;
                            _this.selectAddress(_this.addresses[0]);
                        }
                        _this.settings.sendingData = false;
                    }).catch(function (e) {
                        _this.settings.sendingData = false;
                    }).finally(function (e) {
                        _this.settings.sendingData = false;
                    });
            },
            addAddress() {
                var _this = this;
                if (_this.addAddressSettings.sendingData) { return; }
                _this.addAddressSettings.resultMessage = '';
                _this.addAddressSettings.sendingData = true;
                var endpointUrl = window._data.profileApiUrl + 'addaddress';

                axios.post(endpointUrl,
                    {
                        cityId: _this.addAddressData.city,
                        address: _this.addAddressData.address,
                        additionalInfo: _this.addAddressData.additionalInfo,
                        langAbbr: window._data.languageAbbr
                    }).then(function (response) {
                        _this.addAddressSettings.succeeded = response.data.succeeded;
                        _this.addAddressSettings.sendingData = false;
                        _this.addAddressSettings.resultMessage = response.data.message;

                        if (response.data.succeeded) {
                            $('#address-modal .close').trigger('click')
                            _this.getAddresses();
                        }
                        //else {
                        //    _this.getCartItems();
                        //}
                    }).catch(function (e) {
                        _this.addAddressSettings.sendingData = false;
                    }).finally(function (e) {
                        _this.addAddressSettings.sendingData = false;
                    });
            },
            getCartItems() {
                var _this = this;
                if (_this.settings.sendingData) { return; }
                _this.settings.sendingData = true;
                var endpointUrl = window._data.cartApiUrl + 'getcartitems';
                axios.post(endpointUrl,
                    {
                        langAbbr: window._data.languageAbbr
                    }).then(function (response) {
                        if (response.data.succeeded) {
                            _this.cartItems = response.data.data.cartItems;
                            _this.settings.isAllProductsFromLocalWarehouse = response.data.data.isAllProductsFromLocalWarehouse;
                            window.getCartInfo();
                        }
                        _this.settings.sendingData = false;
                        _this.calculateShipping();
                    }).catch(function (e) {
                        _this.settings.sendingData = false;
                    }).finally(function (e) {
                        _this.settings.sendingData = false;
                    });
            },
            calculateProductSumPrice(cartItem) {
                return (cartItem.quantity * cartItem.product.price).toFixed(2);
            },
            calculateProductSumWeight(cartItem) {
                return (cartItem.quantity * cartItem.product.weight).toFixed(3);
            },
            updateCartItem(cartItem, quantity) {
                var _this = this;
                if (_this.settings.sendingData) { return; }

                _this.settings.sendingData = true;
                var endpointUrl = window._data.cartApiUrl + 'add';
                axios.post(endpointUrl,
                    {
                        productId: cartItem.product.id,
                        quantity: quantity
                    }).then(function (response) {
                        _this.settings.sendingData = false;

                        if (response.data.succeeded) {
                            _this.getCartItems();
                        } else {
                            $('.notification').addClass('fail');
                            $('.notification .notification__text p')[0].innerText = response.data.message;
                            $('.notification').addClass('open');
                            setTimeout(function () {
                                $('.notification').removeClass('open success fail');
                                $('.notification .notification__text p')[0].innerText = '';
                            }, 3000);
                        }
                    }).catch(function (e) {
                        _this.settings.sendingData = false;
                    }).finally(function (e) {
                        _this.settings.sendingData = false;
                    });
            },
            isAddressSelected() {
                var _this = this;
                return _this.selectedOptions.selectedAddress != undefined && _this.selectedOptions.selectedAddress != null;
            },
            selectAddress(address) {
                var _this = this;
                _this.selectedOptions.selectedAddress = address;
                _this.calculateShipping();
            },
            calculateShipping() {
                var _this = this;

                if (_this.settings.sendingData) { return; }

                _this.settings.sendingData = true;
                var endpointUrl = window._data.cartApiUrl + 'getshippingfee';
                axios.post(endpointUrl,
                    {
                        cityId: _this.selectedOptions.selectedAddress.city.id,
                        langAbbr: window._data.languageAbbr
                    }).then(function (response) {
                        if (response.data.succeeded) {
                            _this.shipping.fee = response.data.data.fee.toFixed(2);
                            _this.shipping.days = response.data.data.days;
                        }
                        _this.settings.sendingData = false;
                    }).catch(function (e) {
                        _this.settings.sendingData = false;
                    }).finally(function (e) {
                        _this.settings.sendingData = false;
                    });
            },
            setDeliveryOption(option) {
                var _this = this;
                //0-request, 1-takeaway
                this.selectedOptions.selectedDeliveryOption = option;
                if (option == 0) {
                    _this.calculateShipping();
                } else {
                    _this.shipping.fee = 0;
                    _this.shipping.days = '';
                }
            },
            processCheckout(isReservation) {
                var _this = this;
                if (_this.checkoutSettings.sendingData) { return; }
                _this.checkoutSettings.resultMessage = '';
                _this.checkoutSettings.sendingData = false;
                //_this.getCartItems();
                _this.checkoutSettings.sendingData = false;
                _this.calculateShipping();
                _this.checkoutSettings.sendingData = true;
                var endpointUrl = window._data.cartApiUrl + 'processCheckout';

                if (_this.selectedOptions.selectedPaymentMethod == 5) {

                    BOG.Calculator.open({
                        amount: parseFloat(_this.productsSumPriceWithShipping),
                        onClose: () => {
                            // Modal close callback
                        },
                        onRequest: (selected, successCb, closeCb) => {
                            const {
                                amount, month, discount_code
                            } = selected;
                            axios.post(endpointUrl,
                                {
                                    channel: _this.selectedOptions.selectedPaymentMethod,
                                    requestDelivery: _this.selectedOptions.selectedDeliveryOption == 0 ? true : false,
                                    addressId: _this.selectedOptions.selectedAddress != undefined && _this.selectedOptions.selectedAddress != null ? _this.selectedOptions.selectedAddress.id : null,
                                    langAbbr: window._data.languageAbbr,
                                    isReservation: isReservation,

                                    loanTerm: month,
                                    discountCode: discount_code
                                })
                                .then(function (response) {
                                    _this.checkoutSettings.sendingData = false;
                                    _this.checkoutSettings.resultMessage = response.data.message;
                                    _this.checkoutSettings.succeeded = response.data.succeeded;

                                    if (response.data.succeeded) {
                                        //tbc
                                        if (response.data.data.channel == 0) {
                                            location.href = response.data.data.redirectUrl;
                                        }
                                        //bog
                                        else if (response.data.data.channel == 1) {
                                            location.href = response.data.data.redirectUrl;
                                        }
                                        //tbc installment
                                        else if (response.data.data.channel == 4) {
                                            location.href = response.data.data.redirectUrl;
                                        }
                                        //bog installment
                                        else if (response.data.data.channel == 5) {
                                            location.href = response.data.data.redirectUrl;
                                        }
                                        //bank transfer || pos terminal
                                        else if (response.data.data.channel == 2 || response.data.data.channel == 3) {
                                            location.href = window._data.paymentResultUrl + '?t=' + response.data.data.transactionId + '&i=' + response.data.data.identificator;
                                        }
                                    }
                                    else {
                                        _this.getCartItems();
                                    }
                                })
                                .catch(function (e) {
                                    _this.checkoutSettings.sendingData = false;
                                })
                                .finally(function (e) {
                                    _this.checkoutSettings.sendingData = false;
                                });
                        }
                    })

                } else {
                    axios.post(endpointUrl,
                        {
                            channel: _this.selectedOptions.selectedPaymentMethod,
                            requestDelivery: _this.selectedOptions.selectedDeliveryOption == 0 ? true : false,
                            addressId: _this.selectedOptions.selectedAddress != undefined && _this.selectedOptions.selectedAddress != null ? _this.selectedOptions.selectedAddress.id : null,
                            langAbbr: window._data.languageAbbr,
                            isReservation: isReservation
                        })
                        .then(function (response) {
                            _this.checkoutSettings.sendingData = false;
                            _this.checkoutSettings.resultMessage = response.data.message;
                            _this.checkoutSettings.succeeded = response.data.succeeded;

                            if (response.data.succeeded) {
                                //tbc
                                if (response.data.data.channel == 0) {
                                    location.href = response.data.data.redirectUrl;
                                }
                                //bog
                                else if (response.data.data.channel == 1) {
                                    location.href = response.data.data.redirectUrl;
                                }
                                //tbc installment
                                else if (response.data.data.channel == 4) {
                                    location.href = response.data.data.redirectUrl;
                                }
                                //bank transfer || pos terminal
                                else if (response.data.data.channel == 2 || response.data.data.channel == 3) {
                                    location.href = window._data.paymentResultUrl + '?t=' + response.data.data.transactionId + '&i=' + response.data.data.identificator;
                                }
                            }
                            else {
                                _this.getCartItems();
                            }
                        })
                        .catch(function (e) {
                            _this.checkoutSettings.sendingData = false;
                        })
                        .finally(function (e) {
                            _this.checkoutSettings.sendingData = false;
                        });
                }
            },
            clearCart() {
                var _this = this;
                if (_this.settings.sendingData) { return; }

                _this.settings.sendingData = true;
                var endpointUrl = window._data.cartApiUrl + 'clearcart';
                axios.post(endpointUrl,
                    {
                    }).then(function (response) {
                        _this.settings.sendingData = false;
                        if (response.data.succeeded) {
                            _this.getCartItems();
                        }
                    }).catch(function (e) {
                        _this.settings.sendingData = false;
                    }).finally(function (e) {
                        _this.settings.sendingData = false;
                    });
            },
            //createAndSubmitForm(transId) {
            //    $("body").append('<form id="payform" action="https://ecommerce.ufc.ge/ecomm2/ClientHandler" method="post" name="returnform"><input type="hidden" name="trans_id" value="' + transId + '" /></form>');
            //    $("#payform")[0].submit();
            //},
            selectPaymentMethod(method) {
                var _this = this;
                _this.selectedOptions.selectedPaymentMethod = method;
            }
        },
        mounted() {
            var _this = this;
            _this.getCartItems();
            if (_this.isAuthorized) {
                _this.getCities();
                _this.getAddresses();
            }

            //if (_this.userInfo != null) {
            //    _this.userData.fullname = _this.userInfo.Fullname;
            //    _this.userData.phone = _this.userInfo.Phone;
            //}
        },
        computed: {
            productsSumPrice() {
                var _this = this;
                var sumPrice = 0;
                for (var i = 0; i < _this.cartItems.length; i++) {
                    sumPrice += parseFloat(_this.calculateProductSumPrice(_this.cartItems[i]));
                }
                return sumPrice.toFixed(2);
            },
            productsSumPriceWithShipping() {
                var _this = this;
                var sumPrice = 0;
                for (var i = 0; i < _this.cartItems.length; i++) {
                    sumPrice += parseFloat(_this.calculateProductSumPrice(_this.cartItems[i]));
                }
                sumPrice += parseFloat(_this.shipping.fee);
                return sumPrice.toFixed(2);
            },
            productsSumWeigth() {
                var _this = this;
                var sumWeight = 0;
                for (var i = 0; i < _this.cartItems.length; i++) {
                    sumWeight += parseFloat(_this.calculateProductSumWeight(_this.cartItems[i]));
                }
                return sumWeight;
            },
            productsSumWeightInKg() {
                return this.productsSumWeigth.toFixed(2);
            },
        }
    ,
template: `
    <div class="row">
        <p class="order-list__noentry" v-show="cartItems.length == 0">{{phrases.empty}}</p>
        <div class="col-lg-9" v-show="cartItems.length > 0">
            <table class="table table-cart table-mobile">
                <thead>
                    <tr class="case-on">
                        <th>{{phrases.tableproduct}}</th>
                        <th>{{phrases.tableprice}}</th>
                        <th>{{phrases.tablequantity}}</th>
                        <th>{{phrases.tablesum}}</th>
                        <th></th>
                    </tr>
                </thead>

                <tbody>
                    <tr v-for="cartItem in cartItems">
                        <td class="product-col">
                            <div class="product">
                                <figure class="product-media">
                                    <a href="" @click.prevent="openProductUrl(cartItem.product.url)">
                                        <img :src="cartItem.product.photoUrl" :alt="cartItem.product.title">
                                    </a>
                                </figure>

                                <h3 class="product-title">
                                    <a href="" @click.prevent="openProductUrl(cartItem.product.url)">{{cartItem.product.title}}</a>
                                </h3><!-- End .product-title -->
                            </div><!-- End .product -->
                        </td>
                        <td class="price-col">{{cartItem.product.price.toFixed(2)}} ₾</td>
                        <td class="quantity-col">
                            <div class="cart-product-quantity">
                                <div class="input-group  input-spinner">
                                    <div class="input-group-prepend">
                                        <button style="min-width: 26px" class="btn btn-decrement btn-spinner" type="button"
                                                @click.prevent="decreaseCartItemQuantity(cartItem)">
                                            <i class="icon-minus"></i>
                                        </button>
                                    </div>
                                    <input type="text" style="text-align: center" class="form-control " required="" placeholder="" v-model="cartItem.quantity" disabled>
                                    <div class="input-group-append">
                                        <button style="min-width: 26px" class="btn btn-increment btn-spinner" type="button"
                                                @click.prevent="increaseCartItemQuantity(cartItem)">
                                            <i class="icon-plus"></i>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </td>
                        <td class="total-col">{{calculateProductSumPrice(cartItem)}} ₾</td>
                        <td class="remove-col"><button class="btn-remove" @click.prevent="deleteCartItem(cartItem)"><i class="icon-close"></i></button></td>
                    </tr>

                </tbody>
            </table><!-- End .table table-wishlist -->

            <div class="cart-bottom">

            </div><!-- End .cart-bottom -->
        </div><!-- End .col-lg-9 -->
        <aside class="col-lg-3" v-show="cartItems.length > 0">
            <div class="summary summary-cart">
                <h3 class="summary-title case-on">{{phrases.cart_selectdeliverymethod}}</h3><!-- End .summary-title -->
                <div class="accordion-summary" id="accordion-shipping">
                    <div class="card">
                        <div class="card-header" id="shipping-heading-1">
                            <h2 class="card-title case-on">
                                <a role="button" data-toggle="collapse" href="#shipping-collapse-1" aria-expanded="true" aria-controls="shipping-collapse-1"
                                   @click.prevent="setDeliveryOption(0)">
                                    {{phrases.deliverymethod_courier}}
                                </a>
                            </h2>
                        </div>
                        <div id="shipping-collapse-1" class="collapse show" aria-labelledby="shipping-heading-1" data-parent="#accordion-shipping">
                            <div class="card-body action-col">
                                <div class="dropdown mb-1" v-show="addresses.length > 0">
                                    <button class="btn btn-block btn-outline-primary-2 jcl" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"
                                            v-if="selectedOptions.selectedAddress != null">
                                        {{selectedOptions.selectedAddress.title}}
                                    </button>

                                    <div class="dropdown-menu">
                                        <a class="dropdown-item" href="" @click.prevent="selectAddress(address)" v-for="(address, index) in addresses">{{address.title}}</a>
                                    </div>
                                </div>
                                <a href="#address-modal" v-show="isAuthorized"
                                   class="btn btn-outline-primary-2 btn-order btn-block case-on"
                                   data-toggle="modal">{{phrases.cart_addaddress}}</a>

                                <a href="#signin-modal" v-show="!isAuthorized"
                                   class="btn btn-outline-primary-2 btn-order btn-block case-on"
                                   data-toggle="modal">{{phrases.cart_addaddress}}</a>

                                <div class="hint">
                                    {{shipping.days}}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="card">
                        <div class="card-header" id="shipping-heading-2">
                            <h2 class="card-title case-on">
                                <a class="collapsed" role="button" data-toggle="collapse" href="#shipping-collapse-2" aria-expanded="false" aria-controls="shipping-collapse-2"
                                   @click.prevent="setDeliveryOption(1)">
                                    {{phrases.deliverymethod_takeaway}}
                                </a>
                            </h2>
                        </div>
                        <div id="shipping-collapse-2" class="collapse" aria-labelledby="shipping-heading-2" data-parent="#accordion-shipping">
                            <div class="card-body">
                                {{phrases.deliverymethod_takeawaydescription}}
                            </div>
                        </div>
                    </div>

                </div>

                <h3 class="summary-title case-on">{{phrases.selectpaymentmethod}}</h3><!-- End .summary-title -->
                <div class="accordion-summary" id="accordion-payment">

                    <div class="card">
                        <div class="card-header" id="heading-1">
                            <h2 class="card-title case-on">
                                <a role="button" data-toggle="collapse" href="#collapse-1" aria-expanded="true" aria-controls="collapse-1" @click.prevent="selectPaymentMethod(0)">
                                    {{phrases.paymentmethod_tbccard}}
                                    <img src="~/m/images/payments.png" alt="payments cards">
                                </a>
                            </h2>
                        </div>
                        <div id="collapse-1" class="collapse show" aria-labelledby="heading-1" data-parent="#accordion-payment">
                            <div class="card-body">
                                {{phrases.paymentmethod_tbccarddescription}}
                            </div>
                        </div>
                    </div>

                    <div class="card">
                        <div class="card-header" id="heading-2">
                            <h2 class="card-title case-on">
                                <a class="collapsed" role="button" data-toggle="collapse" href="#collapse-2" aria-expanded="true" aria-controls="collapse-2" @click.prevent="selectPaymentMethod(2)">
                                    {{phrases.paymentmethod_banktransfer}}
                                </a>
                            </h2>
                        </div>
                        <div id="collapse-2" class="collapse" aria-labelledby="heading-2" data-parent="#accordion-payment">
                            <div class="card-body">
                                {{phrases.paymentmethod_banktransferdescription}}
                            </div>
                        </div>
                    </div>

                    <div class="card" v-if="selectedOptions.selectedAddress != null" v-show="selectedOptions.selectedAddress.city.id == 1">
                        <div class="card-header" id="heading-3">
                            <h2 class="card-title case-on">
                                <a class="collapsed" role="button" data-toggle="collapse" href="#collapse-3" aria-expanded="false" aria-controls="collapse-3" @click.prevent="selectPaymentMethod(3)">
                                    {{phrases.paymentmethod_pos}}
                                </a>
                            </h2>
                        </div>
                        <div id="collapse-3" class="collapse" aria-labelledby="heading-3" data-parent="#accordion-payment">
                            <div class="card-body">
                                {{phrases.paymentmethod_posdescription}}
                            </div>
                        </div>
                    </div>

                    <div class="card">
                        <div class="card-header" id="heading-4">
                            <h2 class="card-title case-on">
                                <a class="collapsed" role="button" data-toggle="collapse" href="#collapse-4" aria-expanded="false" aria-controls="collapse-4" @click.prevent="selectPaymentMethod(4)">
                                    {{phrases.paymentmethod_tbcinstallment}}
                                </a>
                            </h2>
                        </div>
                        <div id="collapse-4" class="collapse" aria-labelledby="heading-4" data-parent="#accordion-payment">
                            <div class="card-body">
                                {{phrases.paymentmethod_tbcinstallmentdescription}}
                            </div>
                        </div>
                    </div>

                    <div class="card">
                        <div class="card-header" id="heading-5">
                            <h2 class="card-title case-on">
                                <a class="collapsed" role="button" data-toggle="collapse" href="#collapse-5" aria-expanded="true" aria-controls="collapse-5" @click.prevent="selectPaymentMethod(5)">
                                    {{phrases.paymentmethod_boginstallment}}
                                </a>
                            </h2>
                        </div>
                        <div id="collapse-5" class="collapse" aria-labelledby="heading-5" data-parent="#accordion-payment">
                            <div class="card-body">
                                {{phrases.paymentmethod_boginstallmentdescription}}
                            </div>
                        </div>
                    </div>

                </div>

                <table class="table table-summary">
                    <tbody>
                        <tr class="summary-subtotal case-on">
                            <td>{{phrases.cart_sumproducts}}</td>
                            <td>{{productsSumPrice}}&nbsp;₾</td>
                        </tr><!-- End .summary-subtotal -->
                        <tr class="summary-subtotal case-on">
                            <td>{{phrases.cart_sumweight}}</td>
                            <td>{{productsSumWeightInKg}}&nbsp;კგ.</td>
                        </tr><!-- End .summary-subtotal -->
                        <tr class="summary-subtotal case-on">
                            <td>{{phrases.cart_shipping}}</td>
                            <td>{{shipping.fee}}&nbsp;₾</td>
                        </tr><!-- End .summary-subtotal -->
                        <tr class="summary-subtotal case-on">
                            <td>{{phrases.cart_sum}}</td>
                            <td><strong>{{productsSumPriceWithShipping}}&nbsp;₾</strong></td>
                        </tr><!-- End .summary-subtotal -->
                    </tbody>
                </table><!-- End .table table-summary -->

                <div class="alert mb-xl-1" v-if="!checkoutSettings.sendingData" :class="{'alert-danger' : checkoutSettings.succeeded == false,'alert-success' : checkoutSettings.succeeded == true  }">
                    {{checkoutSettings.resultMessage}}
                </div>

                <a href="#signin-modal" v-show="!isAuthorized" class="btn btn-outline-primary-2 btn-order btn-block case-on" data-toggle="modal">{{phrases.cart_processcheckout}}</a>
                <a href="#address-modal" v-show="isAuthorized && (selectedOptions.selectedDeliveryOption == 0 && !isAddressSelected())" class="btn btn-outline-primary-2 btn-order btn-block case-on" data-toggle="modal">{{phrases.cart_processcheckout}}</a>
                <a href="" @click.prevent="processCheckout(false)" v-show="isAuthorized && ((selectedOptions.selectedDeliveryOption == 0 && isAddressSelected()) || selectedOptions.selectedDeliveryOption == 1)" class="btn btn-outline-primary-2 btn-order btn-block case-on">
                    <span v-show="!checkoutSettings.sendingData">{{phrases.cart_processcheckout}}</span>
                    <span v-show="checkoutSettings.sendingData">{{phrases.cart_processing}}</span>
                </a>

                <a href="" @click.prevent="processCheckout(true)" v-show="isAuthorized && !isPhysical && selectedOptions.selectedPaymentMethod == 2 && ((selectedOptions.selectedDeliveryOption == 0 && isAddressSelected()) || selectedOptions.selectedDeliveryOption == 1)" class="btn btn-outline-primary-2 btn-order btn-block case-on">
                    <span v-show="!checkoutSettings.sendingData">{{phrases.cart_processreserve}}</span>
                    <span v-show="checkoutSettings.sendingData">{{phrases.cart_processing}}</span>
                </a>

            </div><!-- End .summary -->

            <a href="" @click.prevent="gotoHome()" class="btn btn-outline-dark-2 btn-block mb-3 case-on"><span>{{phrases.cart_returntoshop}}</span><i class="icon-refresh"></i></a>
        </aside><!-- End .col-lg-3 -->



        <div class="modal fade" id="address-modal" tabindex="-1" role="dialog" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-body">
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true"><i class="icon-close"></i></span>
                        </button>
                        <div class="form-box">
                            <div class="form-tab">
                                <ul class="nav nav-pills nav-fill case-on" role="tablist">
                                    <li class="nav-item">
                                        <a class="nav-link active" id="signin-tab" data-toggle="tab" href="#signin" role="tab" aria-controls="signin" aria-selected="true">მისამართის დამატება</a>
                                    </li>
                                </ul>

                                <div class="tab-content" id="tab-content-5">
                                    <div class="tab-pane fade show active" id="signin" role="tabpanel" aria-labelledby="signin-tab">
                                        <div action="#">
                                            <div class="form-group">

                                                <label for="address-city">{{phrases.addresscity}}</label>
                                                <div class="select-custom">
                                                    <select name="size" id="size" class="form-control" v-model="addAddressData.city">
                                                        <option v-for="city in cities" :value="city.id">
                                                            {{city.title}}
                                                        </option>
                                                    </select>
                                                </div><!-- End .select-custom -->
                                                <!--<input type="text" class="form-control" id="add-address-city" name="address-city" v-model="addAddressData.city">-->
                                            </div>
                                            <div class="form-group">
                                                <label for="address-address">{{phrases.addressstreet}}</label>
                                                <input type="text" class="form-control" id="add-address-address" name="address-address" v-model="addAddressData.address">
                                            </div>
                                            <div class="form-group">
                                                <label for="address-additional-info">{{phrases.addressadditionalinfo}}</label>
                                                <textarea class="form-control" id="add-address-additional-info" name="address-additional-info" v-model="addAddressData.additionalInfo"></textarea>
                                            </div>

                                            <div class="alert alert-danger" v-show="addAddressSettings.succeeded == false">
                                                {{addAddressSettings.resultMessage}}
                                            </div>
                                            <div class="form-footer">
                                                <button type="submit" class="btn btn-outline-primary-2 case-on"
                                                        @click.prevent="addAddress()">
                                                    <span v-show="!addAddressSettings.sendingData">{{phrases.addressaddbutton}}</span>
                                                    <span v-show="addAddressSettings.sendingData">{{phrases.addresswaitbutton}}</span>
                                                    <i class="icon-long-arrow-right"></i>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div><!-- End .tab-content -->
                            </div><!-- End .form-tab -->
                        </div><!-- End .form-box -->
                    </div><!-- End .modal-body -->
                </div><!-- End .modal-content -->
            </div><!-- End .modal-dialog -->
        </div>


    </div><!-- End .row -->
`
});
Vue.component('changePassword', {
        props: {
            setByUser: Boolean
        },
        data: function () {
            return {
                oldPassword: '',
                newPassword: '',
                repeatNewPassword: '',
                settings: {
                    sendingData: false,
                    submitted: false,
                    resultMessage: '',
                    succeeded: null
                },
                phrases: {
                    oldPassword: PhrasesService.shared.getPhrase('profilechangepassword_oldpassword'),
                    newPassword: PhrasesService.shared.getPhrase('profilechangepassword_newpassword'),
                    repeatnewPassword: PhrasesService.shared.getPhrase('profilechangepassword_repeatnewpassword'),
                    save: PhrasesService.shared.getPhrase('profilechangepassword_save'),
                },
            };
        },
        methods: {
            changePassword() {
                var _this = this;
                if (_this.settings.sendingData) { return; }
                _this.settings.submitted = true;

                if (!_this.oldPassword.length || !_this.newPassword.length || !_this.repeatNewPassword.length) {
                    return;
                }

                _this.settings.sendingData = true;
                _this.settings.resultMessage = '';

                axios.post(window._data.profileApiUrl + 'changepassword',
                    {
                        oldPassword: _this.oldPassword,
                        newPassword: _this.newPassword,
                        repeatNewPassword: _this.repeatNewPassword,
                        langAbbr: window._data.languageAbbr
                    }).then(function (response) {
                        //if (response.data.succeeded) {
                        //    // window.location.href = response.data.data.redirectUrl;
                        //}
                        _this.settings.succeeded = response.data.succeeded;
                        _this.settings.resultMessage = response.data.message;
                        _this.settings.sendingData = false;
                    }).catch(function (e) {
                        _this.settings.sendingData = false;
                    }).finally(function (e) {
                        _this.settings.sendingData = false;
                    });
            }
        },
        mounted() {
        }
    ,
template: `
    <div class="form">
        <div class="row">
            <div class="col-sm-4">
                <label>{{phrases.oldPassword}}</label>
                <input type="password" class="form-control" v-model="oldPassword"
                       :class="{'has-error' : settings.submitted && (oldPassword == null ||!oldPassword.length)}">
            </div><!-- End .col-sm-6 -->

            <div class="col-sm-4">
                <label>{{phrases.newPassword}}</label>
                <input type="password" class="form-control" v-model="newPassword"
                       :class="{'has-error' : settings.submitted && (newPassword == null ||!newPassword.length)}">
            </div><!-- End .col-sm-6 -->

            <div class="col-sm-4">
                <label>{{phrases.repeatnewPassword}}</label>
                <input type="password" class="form-control" v-model="repeatNewPassword"
                       :class="{'has-error' : settings.submitted && (repeatNewPassword == null || !repeatNewPassword.length)}">
            </div><!-- End .col-sm-6 -->
        </div><!-- End .row -->

        <div class="alert mb-xl-1" v-if="!settings.sendingData" :class="{'alert-danger' : settings.succeeded == false,'alert-success' : settings.succeeded == true  }">
            {{settings.resultMessage}}
        </div>

        <button type="submit" class="btn btn-outline-primary-2"
                @click.prevent="changePassword()">
            <span v-show="!settings.sendingData">{{phrases.save}}</span>
            <span v-show="settings.sendingData">დაელოდეთ...</span>
            <i class="icon-long-arrow-right"></i>
        </button>
    </div>
`
});
Vue.component('contact', {
        props: { recaptcha: String },
        data: function () {
            return {
                userData: {
                    firstname: '',
                    lastname: '',
                    email: '',
                    phone: '',
                    message: ''
                },
                settings: {
                    sendingData: false,
                    submitted: false,
                    resultMessage: '',
                    succeeded: null
                },
            };
        },
        methods: {
            //enableBtn() {
            //    $('.js-send').removeClass("disabled");
            //},
            send() {
                var _this = this;
                if (_this.settings.sendingData) { return; }

                _this.settings.submitted = true;
                _this.settings.resultMessage = '';

                if (!_this.userData.firstname.length || !_this.userData.lastname.length
                    || !_this.userData.email.length || !_this.userData.phone.length
                    || !_this.userData.message.length) {
                    return;
                }
                _this.settings.sendingData = true;

                axios.post(window._data.contactApiUrl + 'send',
                    {
                        firstname: _this.userData.firstname,
                        lastname: _this.userData.lastname,
                        email: _this.userData.email,
                        phone: _this.userData.phone,
                        message: _this.userData.message,
                        captcha: $("#g-recaptcha-response").val()
                    }).then(function (response) {
                        _this.settings.succeeded = response.data.succeeded;
                        _this.settings.resultMessage = response.data.message;
                        _this.settings.sendingData = false;
                    }).catch(function (e) {
                        _this.settings.sendingData = false;
                    }).finally(function (e) {
                        _this.settings.sendingData = false;
                    });
            },
        },
        mounted() {
        }
    ,
template: `
    <div class="contact__form">
        <h3 class="contact__box-title">მოგვწერეთ</h3>
        <div class="form" v-show="!settings.succeeded">



            <div class="form__group">
                <label for="" class="form__label">სახელი</label>
                <div class="form__content">
                    <input type="text" class="form-control" placeholder="" v-model="userData.firstname" :class="{'has-error' : settings.submitted && !userData.firstname.length}">
                </div>
            </div>
            <div class="form__group">
                <label for="" class="form__label">გვარი</label>
                <div class="form__content">
                    <input type="text" class="form-control" placeholder="" v-model="userData.lastname" :class="{'has-error' : settings.submitted && !userData.lastname.length}">
                </div>
            </div>
            <div class="form__group">
                <label for="" class="form__label">ელ.ფოსტა</label>
                <div class="form__content">
                    <input type="text" class="form-control" placeholder="" v-model="userData.email" :class="{'has-error' : settings.submitted && !userData.email.length}">
                </div>
            </div>
            <div class="form__group">
                <label for="" class="form__label">ტელეფონი</label>
                <div class="form__content">
                    <input type="text" class="form-control" placeholder="" v-model="userData.phone" :class="{'has-error' : settings.submitted && !userData.phone.length}">
                </div>
            </div>
            <div class="form__group form__group--fullwidth">
                <label for="" class="form__label">წერილი</label>
                <div class="form__content">
                    <textarea class="form-control" placeholder="" v-model="userData.message" :class="{'has-error' : settings.submitted && !userData.message.length}"></textarea>
                </div>
            </div>
            <div class="alert mb-xl-1" v-if="!settings.sendingData" :class="{'alert-danger' : settings.succeeded == false,'alert-success' : settings.succeeded == true  }">
                {{settings.resultMessage}}
            </div>
            <div class="text-left">
                <div class="form__captcha">
                    <div class="g-recaptcha" :data-sitekey="recaptcha" data-callback="enableBtn"></div>
                </div>
                <button type="submit" class="btn btn-outline-primary-2 btn-minwidth-sm js-send disabled"
                        @click.prevent="send()">
                    <span v-show="!settings.sendingData">გაგზავნა</span>
                    <span v-show="settings.sendingData">დაელოდეთ...</span>
                    <i class="icon-long-arrow-right"></i>
                </button>
            </div><!-- End .text-center -->


        </div>

    </div>
`
});
Vue.component('offer', {
        props: [],
        data: function () {
            return {
                userData: {
                    firstname: '',
                    lastname: '',
                    email: '',
                    phone: '',
                    offerId: ''
                },
                settings: {
                    sendingData: false,
                    submitted: false,
                    resultMessage: '',
                    succeeded: null
                },
            };
        },
        methods: {
            send() {
                var _this = this;
                if (_this.settings.sendingData) { return; }

                _this.settings.submitted = true;
                _this.settings.resultMessage = '';
                if (!_this.userData.firstname.length || !_this.userData.lastname.length
                    || !_this.userData.email.length || !_this.userData.phone.length) {
                    return;
                }
                _this.settings.sendingData = true;

                axios.post(window._data.offerApiUrl + 'send',
                    {
                        firstname: _this.userData.firstname,
                        lastname: _this.userData.lastname,
                        email: _this.userData.email,
                        phone: _this.userData.phone,
                        offerId: window.selectedOfferId
                    }).then(function (response) {
                        _this.settings.succeeded = response.data.succeeded;
                        _this.settings.resultMessage = response.data.message;
                        _this.settings.sendingData = false;
                    }).catch(function (e) {
                        _this.settings.sendingData = false;
                    }).finally(function (e) {
                        _this.settings.sendingData = false;
                    });
            },
        },
        mounted() {
        }
    ,
template: `
    <div>
        <div class="dialog__head">
            <h3 class="dialog__title">მსურს შეძენა</h3>
            <a href="" data-fancybox-close class="dialog__close">
                <svg class="dialog__close-icon">
                    <use xlink:href="~/m/i/icons.svg#symbol-times"></use>
                </svg>
            </a>
        </div>

        <div v-show="!settings.succeeded">
            <div class="dialog__body">
                <div class="form">
                    <div class="form__group"
                         :class="{'has-error' : settings.submitted && !userData.firstname.length}">
                        <input type="text" class="form__element" placeholder="სახელი" v-model="userData.firstname">
                    </div>
                    <div class="form__group"
                         :class="{'has-error' : settings.submitted && !userData.lastname.length}">
                        <input type="text" class="form__element" placeholder="გვარი" v-model="userData.lastname">
                    </div>
                    <div class="form__group"
                         :class="{'has-error' : settings.submitted && !userData.email.length}">
                        <input type="email" class="form__element" placeholder="ელფოსტა" v-model="userData.email">
                    </div>
                    <div class="form__group"
                         :class="{'has-error' : settings.submitted && !userData.phone.length}">
                        <input type="tel" class="form__element" placeholder="მობილური" v-model="userData.phone">
                    </div>
                </div>
            </div>
            <div class="dialog__actions">
                <a href="" data-fancybox-close class="button button--gray button--default">
                    <span class="button__text">გაუქმება</span>
                </a>
                <a href="" class="button button--primary button--default"
                   @click.prevent="send()"
                   :class="{'loading' : settings.sendingData}">
                    <span class="button__text">გაგზავნა</span>
                    <svg class="button__icon button__icon--send">
                        <use xlink:href="~/m/i/icons.svg#symbol-send"></use>
                    </svg>
                    <div class="spinner"></div>
                </a>
            </div>
        </div>
        <div class="dialog__body"
             v-show="settings.resultMessage.length">
            <div class="general-message "
                 :class="{'general-message--success' : settings.succeeded, 'general-message--error' : !settings.succeeded}">
                <div class="general-message__icon-wrap">
                    <svg class="general-message__icon">
                        <use xlink:href="~/m/i/icons.svg#symbol-info"></use>
                    </svg>
                </div>
                <span class="general-message__text">{{settings.resultMessage}}</span>
            </div>
        </div>
    </div>
`
});
Vue.component('profile', {
        props: {
            userInfo: Object
        },
        data: function () {
            return {
                settings: {
                    sendingData: false,
                    submitted: false,
                    resultMessage: '',
                    succeeded: null
                },
                userData: {
                    fullname: '',
                    mobile: '',
                    code: '',
                    //birthDate: '',
                    //gender: 0,
                },
                phrases: {
                    fullname: PhrasesService.shared.getPhrase('profile_fullname'),
                    email: PhrasesService.shared.getPhrase('profile_email'),
                    phone: PhrasesService.shared.getPhrase('profile_phone'),
                    personalId: PhrasesService.shared.getPhrase('profile_personalid'),

                    code: PhrasesService.shared.getPhrase('profile_code'),
                    gendeoptionchoose: PhrasesService.shared.getPhrase('profile_gendeoptionchoose'),
                    genderoptionmale: PhrasesService.shared.getPhrase('profile_genderoptionmale'),
                    genderoptionfemale: PhrasesService.shared.getPhrase('profile_genderoptionfemale'),
                    birthDate: PhrasesService.shared.getPhrase('profile_birthdate'),
                    save: PhrasesService.shared.getPhrase('profile_save'),
                    wait: PhrasesService.shared.getPhrase('profile_wait')
                },
            };
        },
        methods: {
            updateInfo() {
                var _this = this;
                if (_this.settings.sendingData) { return; }
                _this.settings.submitted = true;
                _this.settings.resultMessage = '';

                if ((_this.userData.fullname != null && !_this.userData.fullname.length) ||
                    (_this.userData.mobile != null && !_this.userData.mobile.length) ||
                    (_this.userData.code != null && !_this.userData.code.length)) {
                    return;
                }
                _this.settings.sendingData = true;

                axios.post(window._data.profileApiUrl + 'updateinfo',
                    {
                        name: _this.userData.fullname,
                        mobile: _this.userData.mobile,
                        code: _this.userData.code,
                        langAbbr: window._data.languageAbbr
                    }).then(function (response) {
                        //if (response.data.succeeded) {
                        //    // window.location.href = response.data.data.redirectUrl;
                        //}
                        _this.settings.succeeded = response.data.succeeded;
                        _this.settings.resultMessage = response.data.message;
                        _this.settings.sendingData = false;
                    }).catch(function (e) {
                        _this.settings.sendingData = false;
                    }).finally(function (e) {
                        _this.settings.sendingData = false;
                    });
            },

            allowNumbersOnly(evt) {
                evt = (evt) ? evt : window.event;
                var charCode = (evt.which) ? evt.which : evt.keyCode;
                if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
                    evt.preventDefault();;
                } else {
                    return true;
                }
            },
        },
        mounted() {
            var _this = this;

            _this.userData.fullname = _this.userInfo.Fullname;
            _this.userData.email = _this.userInfo.Email;
            _this.userData.mobile = _this.userInfo.Mobile;
            _this.userData.code = _this.userInfo.Code;
        }
    ,
template: `
    <div class="form">
        <div class="row">
            <div class="col-sm-6">
                <label>{{phrases.fullname}}</label>
                <input type="text" class="form-control" v-model="userData.fullname"
                       :class="{'has-error' : settings.submitted && (userData.fullname == null ||!userData.fullname.length)}">
            </div><!-- End .col-sm-6 -->

            <div class="col-sm-6">
                <label>{{phrases.email}}</label>
                <input type="text" class="form-control" v-model="userData.email" disabled>
            </div><!-- End .col-sm-6 -->
        </div><!-- End .row -->

        <div class="row">
            <div class="col-sm-6">
                <label>{{phrases.phone}}</label>
                <input type="text" class="form-control" v-model="userData.mobile"
                       :class="{'has-error' : settings.submitted && (userData.mobile == null ||!userData.mobile.length)}">
            </div><!-- End .col-sm-6 -->

            <div class="col-sm-6">
                <label>{{phrases.personalId}}</label>
                <input type="text" class="form-control" v-model="userData.code"
                       :class="{'has-error' : settings.submitted && (userData.code == null || !userData.code.length)}">
            </div><!-- End .col-sm-6 -->
        </div><!-- End .row -->

        <div class="alert mb-xl-1" v-if="!settings.sendingData" :class="{'alert-danger' : settings.succeeded == false,'alert-success' : settings.succeeded == true  }">
            {{settings.resultMessage}}
        </div>

        <button type="submit" class="btn btn-outline-primary-2"
                @click.prevent="updateInfo()">
            <span v-show="!settings.sendingData">{{phrases.save}}</span>
            <span v-show="settings.sendingData">{{phrases.wait}}</span>
            <i class="icon-long-arrow-right"></i>
        </button>
    </div>
`
});
Vue.component('recoverPassword', {
        props: [],
        data: function () {
            return {
                userData: {
                    email: ''
                },
                settings: {
                    sendingData: false,
                    submitted: false,
                    resultMessage: '',
                    succeeded: null,
                },
            };
        },
        methods: {
            send() {
                var _this = this;
                if (_this.settings.sendingData) { return; }

                _this.settings.submitted = true;
                _this.settings.resultMessage = '';

                if (!_this.userData.email.length) {
                    return;
                }
                _this.settings.sendingData = true;

                axios.post(window._data.authUrl + 'recoverpassword',
                    {
                        email: _this.userData.email,
                    }).then(function (response) {
                      
                        _this.settings.succeeded = response.data.succeeded;
                        _this.settings.resultMessage = response.data.message;
                        _this.settings.sendingData = false;
                    }).catch(function (e) {
                        _this.settings.sendingData = false;
                    }).finally(function (e) {
                        _this.settings.sendingData = false;
                    });
            }
        },
        mounted() {
        },
        computed: {

        }
    ,
template: `
    <div class="auth-block__info">
        <div class="form" v-show="!settings.succeeded">

            <div class="form__group form__group--fullwidth"
                 :class="{'has-error' : settings.submitted && !userData.email.length}">
                <label for="" class="form__label">ელ. ფოსტა</label>
                <div class="form__content">
                    <input type="email" class="form__element" placeholder="" v-model="userData.email" name="email">
                </div>
            </div>

            <div class="form__group form__group--fullwidth">
                <a href="" class="button button--primary button--default"
                   @click.prevent="send()"
                   :class="{'loading' : settings.sendingData}">
                    <span class="button__text">გაგზავნა</span>
                    <svg-icon class="button__icon button__icon--login" icon="symbol-login"></svg-icon>
                    <div class="spinner"></div>
                </a>
            </div>
        </div>
        <div class="general-message "
             :class="{'general-message--success' : settings.succeeded, 'general-message--error' : !settings.succeeded}"
             v-show="settings.resultMessage.length">
            <div class="general-message__icon-wrap">
                <svg class="general-message__icon">
                    <use xlink:href="~/m/i/icons.svg#symbol-info"></use>
                </svg>
            </div>
            <span class="general-message__text">{{settings.resultMessage}}</span>
        </div>
    </div>
`
});
Vue.component('resetPassword', {
        props: {
            user: Object,
            guid: Object
        },
        data: function () {
            return {
                userData: {
                    password: '',
                    repeatPassword: ''
                },
                settings: {
                    sendingData: false,
                    submitted: false,
                    resultMessage: '',
                    succeeded: null
                },
            };
        },
        methods: {
            send() {
                var _this = this;
                if (_this.settings.sendingData) { return; }

                _this.settings.submitted = true;
                _this.settings.resultMessage = '';

                if (!_this.userData.password.length || !_this.userData.repeatPassword.length) {
                    return;
                }
                _this.settings.sendingData = true;

                axios.post(window._data.authUrl + 'resetpassword',
                    {
                        userId: _this.user,
                        guid: _this.guid,
                        password: _this.userData.password,
                        repeatPassword: _this.userData.repeatPassword
                    }).then(function (response) {
                        if (response.data.succeeded) {
                            location.href = window._data.signInUrl;
                        }
                        _this.settings.succeeded = response.data.succeeded;
                        _this.settings.resultMessage = response.data.message;
                        _this.settings.sendingData = false;
                    }).catch(function (e) {
                        _this.settings.sendingData = false;
                    }).finally(function (e) {
                        _this.settings.sendingData = false;
                    });
            }
        },
        mounted() {
        },
        computed: {

        }
    ,
template: `
    <div class="form-box">
        <div class="form">

            <div class="form__group ">
                <label for="" class="">პაროლი</label>
                <input type="password" class="form-control" placeholder="" v-model="userData.password" autocomplete="off" name="password"
                       :class="{'has-error' : settings.submitted && !userData.password.length}">
            </div>
            <div class="form__group ">
                <label for="" class="">გაიმეორეთ პაროლი</label>
                <input type="password" class="form-control" placeholder="" v-model="userData.repeatPassword" autocomplete="off" name="repeatpassword"
                       :class="{'has-error' : settings.submitted && !userData.repeatPassword.length}">
            </div>

            <div class="alert " :class="{'alert-danger' : settings.succeeded == false, 'alert-success' : settings.succeeded == true}" v-show="settings.resultMessage.length > 0">
                {{settings.resultMessage}}
            </div>

            <div class="form-footer">
                <button class="btn btn-outline-primary-2 case-on"
                        @click.prevent="send()">
                    <span v-show="!settings.sendingData">გაგზავნა</span>
                    <span v-show="settings.sendingData">დაელოდეთ ...</span>
                    <i class="icon-long-arrow-right"></i>
                </button>
            </div>
        </div>

    </div>
`
});
Vue.component('signIn', {
        props: [],
        data: function () {
            return {
                resetPasswordData: {
                    email: ''
                },
                signInData: {
                    email: '',
                    password: '',
                    remember: false
                },
                signUpData: {
                    type: '0',
                    name: '',
                    email: '',
                    mobile: '',
                    code: '',
                    password: '',
                    repeatPassword: '',
                    vatType: ''
                },
                signUpSettings: {
                    sendingData: false,
                    submitted: false,
                    resultMessage: '',
                    succeeded: null
                },
                signInSettings: {
                    sendingData: false,
                    submitted: false,
                    resultMessage: '',
                    succeeded: null
                },
                resetPasswordSettings: {
                    sendingData: false,
                    submitted: false,
                    resultMessage: '',
                    succeeded: null
                },
                //settings: {
                //    //sendingSignUpData: false,
                //    sendingSignInData: false,

                //    submitted: false,
                //    resultMessage: '',
                //    signUpUrl: '',
                //    recoverPasswordUrl: '',
                //    succeeded: null
                //},
                phrases: {
                    signin_signin: PhrasesService.shared.getPhrase('signin_signin'),
                    signin_email: PhrasesService.shared.getPhrase('signin_email'),
                    signin_password: PhrasesService.shared.getPhrase('signin_password'),
                    signin_signinbuttontitle: PhrasesService.shared.getPhrase('signin_signinbuttontitle'),
                    signin_remember: PhrasesService.shared.getPhrase('signin_remember'),
                    signin_forgot: PhrasesService.shared.getPhrase('signin_forgot'),
                    signin_orsignup: PhrasesService.shared.getPhrase('signin_orsignup'),
                    signin_signup: PhrasesService.shared.getPhrase('signin_signup'),
                    signup_physical: PhrasesService.shared.getPhrase('signup_physical'),
                    signup_legal: PhrasesService.shared.getPhrase('signup_legal'),
                    signup_fullname: PhrasesService.shared.getPhrase('signup_fullname'),
                    signup_email: PhrasesService.shared.getPhrase('signup_email'),
                    signup_personalid: PhrasesService.shared.getPhrase('signup_personalid'),
                    signup_mobile: PhrasesService.shared.getPhrase('signup_mobile'),
                    signup_password: PhrasesService.shared.getPhrase('signup_password'),
                    signup_repeatpassword: PhrasesService.shared.getPhrase('signup_repeatpassword'),
                    signup_signupbuttontitle: PhrasesService.shared.getPhrase('signup_signupbuttontitle'),
                    signup_agree: PhrasesService.shared.getPhrase('signup_agree'),
                    signup_rules: PhrasesService.shared.getPhrase('signup_rules'),
                    signup_companyname: PhrasesService.shared.getPhrase('signup_companyname'),
                    signup_identitycode: PhrasesService.shared.getPhrase('signup_identitycode'),
                    signup_watpayer: PhrasesService.shared.getPhrase('signup_watpayer'),
                    signup_yes: PhrasesService.shared.getPhrase('signup_yes'),
                    signup_no: PhrasesService.shared.getPhrase('signup_no'),
                    signup_wait: PhrasesService.shared.getPhrase('signup_wait'),
                    resetpassword_buttontitle: PhrasesService.shared.getPhrase('resetpassword_buttontitle'),
                    resetpassword_back: PhrasesService.shared.getPhrase('resetpassword_back')
                },
            };
        },
        methods: {
            signUp() {
                var _this = this;
                if (_this.signUpSettings.sendingData) { return; }

                _this.signUpSettings.submitted = true;
                _this.signUpSettings.resultMessage = '';

                if (!_this.signUpData.name.length ||
                    !_this.signUpData.email.length ||
                    !_this.signUpData.mobile.length ||
                    !_this.signUpData.password.length ||
                    !_this.signUpData.repeatPassword.length ||
                    (_this.signUpData.type == '1' && !_this.signUpData.code.length) ||
                    (_this.signUpData.type == '1' && !_this.signUpData.vatType.length)
                ) {
                    return;
                }

                _this.signUpSettings.sendingData = true;

                axios.post(window._data.authUrl + 'emailsignup',
                    {
                        type: parseInt(_this.signUpData.type),
                        name: _this.signUpData.name,
                        email: _this.signUpData.email,
                        mobile: _this.signUpData.mobile,
                        code: _this.signUpData.code,
                        vatType: _this.signUpData.vatType.length ? parseInt(_this.signUpData.vatType) : 0,
                        password: _this.signUpData.password,
                        repeatPassword: _this.signUpData.repeatPassword,
                        langAbbr: window._data.languageAbbr
                    }).then(function (response) {
                        if (response.data.succeeded) {
                            location.reload();
                        }
                        _this.signUpSettings.succeeded = response.data.succeeded;
                        _this.signUpSettings.resultMessage = response.data.message;
                        _this.signUpSettings.sendingData = false;
                    }).catch(function (e) {
                        _this.signUpSettings.sendingData = false;
                    }).finally(function (e) {
                        _this.signUpSettings.sendingData = false;
                    });
            },
            resetPassword() {
                var _this = this;
                if (_this.resetPasswordSettings.sendingData) { return; }

                _this.resetPasswordSettings.sendingData = true;
                _this.resetPasswordSettings.submitted = true;
                _this.resetPasswordSettings.resultMessage = '';
                _this.resetPasswordSettings.succeeded = null;

                axios.post(window._data.authUrl + 'recoverpassword',
                    {
                        email: _this.resetPasswordData.email,
                        langAbbr: window._data.languageAbbr
                    }).then(function (response) {
                        _this.resetPasswordSettings.succeeded = response.data.succeeded;
                        _this.resetPasswordSettings.resultMessage = response.data.message;
                        _this.resetPasswordSettings.sendingData = false;
                    }).catch(function (e) {
                        _this.resetPasswordSettings.sendingData = false;
                    }).finally(function (e) {
                        _this.resetPasswordSettings.sendingData = false;
                    });
            },
            signIn() {
                var _this = this;
                if (_this.signInSettings.sendingData) { return; }

                _this.signInSettings.sendingData = true;
                _this.signInSettings.submitted = true;
                _this.signInSettings.resultMessage = '';
                _this.signInSettings.succeeded = null;

                axios.post(window._data.authUrl + 'emailsignin',
                    {
                        email: _this.signInData.email,
                        password: _this.signInData.password,
                        persistent: _this.signInData.remember,
                        langAbbr: window._data.languageAbbr
                    }).then(function (response) {
                        if (response.data.succeeded) {
                            location.reload();
                        }
                        _this.signInSettings.succeeded = response.data.succeeded;
                        _this.signInSettings.resultMessage = response.data.message;
                        _this.signInSettings.sendingData = false;
                    }).catch(function (e) {
                        _this.signInSettings.sendingData = false;
                    }).finally(function (e) {
                        _this.signInSettings.sendingData = false;
                    });
            },
            allowNumbersOnly(evt) {
                evt = (evt) ? evt : window.event;
                var charCode = (evt.which) ? evt.which : evt.keyCode;
                if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
                    evt.preventDefault();;
                } else {
                    return true;
                }
            },
            openTermsUrl() {
                window.open(window._data.termsUrl, "_blank");
            },
            openSignUpUrl() {
                $('#register-tab').trigger('click');
            },
            openSignInUrl() {
                $('#signin-tab').trigger('click');
            },
        },
        mounted() {
            //this.settings.signUpUrl = window._data.signUpUrl;
            //this.settings.recoverPasswordUrl = window._data.recoverPasswordUrl;
        },
        computed: {

        }
    ,
template: `
    <div class="form-box">
        <div class="form-tab">
            <ul class="nav nav-pills nav-fill case-on" role="tablist">
                <li class="nav-item">
                    <a class="nav-link active" id="signin-tab" data-toggle="tab" href="#signin" role="tab" aria-controls="signin" aria-selected="true">{{phrases.signin_signin}}</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" id="register-tab" data-toggle="tab" href="#register" role="tab" aria-controls="register" aria-selected="false">{{phrases.signin_signup}}</a>
                </li>
            </ul>
            <div class="tab-content" id="tab-content-5">
                <div class="tab-pane fade show active" id="signin" role="tabpanel" aria-labelledby="signin-tab">
                    <div action="#">
                        <div class="form-group">
                            <label for="singin-email">{{phrases.signin_email}}</label>
                            <input type="text" class="form-control" id="singin-email" name="singin-email" v-model="signInData.email">
                        </div>
                        <div class="form-group">
                            <label for="singin-password">{{phrases.signin_password}}</label>
                            <input type="password" class="form-control" id="singin-password" name="singin-password" v-model="signInData.password">
                        </div>
                        <div class="alert alert-danger" v-show="signInSettings.succeeded == false">
                            {{signInSettings.resultMessage}}
                        </div>
                        <div class="form-footer">
                            <button type="submit" class="btn btn-outline-primary-2 case-on"
                                    @click.prevent="signIn()">
                                <span v-show="!signInSettings.sendingData">{{phrases.signin_signinbuttontitle}}</span>
                                <span v-show="signInSettings.sendingData">{{phrases.signup_wait}}</span>
                                <i class="icon-long-arrow-right"></i>
                            </button>
                            <div class="custom-control custom-checkbox">
                                <input type="checkbox" class="custom-control-input" id="signin-remember" v-model="signInData.remember">
                                <label class="custom-control-label" for="signin-remember">{{phrases.signin_remember}}</label>
                            </div>
                            <a id="resetpassword-tab" data-toggle="tab" href="#resetpassword" role="tab" aria-controls="resetpassword" class="forgot-link">{{phrases.signin_forgot}}</a>
                        </div>
                    </div>
                    <div class="form-choice">
                        <p class="text-center">{{phrases.signin_orsignup}}</p>
                        <div class="row">
                            <div class="col-sm-12">
                                <a href="" @click.prevent="openSignUpUrl()" class="btn btn-login case-on">
                                    {{phrases.signin_signup}}
                                </a>
                            </div>
                        </div>
                    </div>
                </div>


                <div class="tab-pane fade" id="resetpassword" role="tabpanel" aria-labelledby="resetpassword-tab">
                    <div action="#">
                        <div class="form-group">
                            <label for="singin-email">{{phrases.signin_email}}</label>
                            <input type="text" class="form-control" id="singin-email" name="singin-email" v-model="resetPasswordData.email">
                        </div>

                        <div class="alert " :class="{'alert-danger' : resetPasswordSettings.succeeded == false, 'alert-success' : resetPasswordSettings.succeeded == true}" v-show="resetPasswordSettings.resultMessage.length > 0">
                            {{resetPasswordSettings.resultMessage}}
                        </div>
                        <div class="form-footer">
                            <button type="submit" class="btn btn-outline-primary-2 case-on"
                                    @click.prevent="resetPassword()">
                                <span v-show="!resetPasswordSettings.sendingData">{{phrases.resetpassword_buttontitle}}</span>
                                <span v-show="resetPasswordSettings.sendingData">{{phrases.signup_wait}}</span>
                                <i class="icon-long-arrow-right"></i>
                            </button>
                        </div>
                    </div>
                    <div class="form-choice">
                        <div class="row">
                            <div class="col-sm-12">
                                <a href="" @click.prevent="openSignInUrl()" class="btn btn-login case-on">
                                    {{phrases.resetpassword_back}}
                                </a>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="tab-pane fade" id="register" role="tabpanel" aria-labelledby="register-tab">
                    <div action="#">
                        <div class="form-group">
                            <div class="row">
                                <div class="col-sm-6">
                                    <div class="custom-control custom-radio">
                                        <input type="radio" id="physical" name="shipping" class="custom-control-input" v-model="signUpData.type" value="0">
                                        <label class="custom-control-label" for="physical">{{phrases.signup_physical}}</label>
                                    </div>
                                </div>
                                <div class="col-sm-6">
                                    <div class="custom-control custom-radio">
                                        <input type="radio" id="legal" name="shipping" class="custom-control-input" v-model="signUpData.type" value="1">
                                        <label class="custom-control-label" for="legal">{{phrases.signup_legal}}</label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <hr />
                        <div class="form-group">
                            <label for="register-code" v-show="signUpData.type == '0'">{{phrases.signup_fullname}}</label>
                            <label for="register-code" v-show="signUpData.type == '1'">{{phrases.signup_companyname}}</label>
                            <!--<label for="register-name">სახელი, გვარი</label>-->
                            <input type="text" class="form-control" id="register-name" name="register-name"
                                   v-model="signUpData.name"
                                   :class="{'has-error' : signUpSettings.submitted && !signUpData.name.length}">
                        </div>
                        <div class="form-group">
                            <label for="register-email">{{phrases.signup_email}}</label>
                            <input type="email" class="form-control" id="register-email" name="register-email"
                                   v-model="signUpData.email"
                                   :class="{'has-error' : signUpSettings.submitted && !signUpData.email.length}">
                        </div>
                        <div class="form-group">
                            <label for="register-code" v-show="signUpData.type == '0'">{{phrases.signup_personalid}}</label>
                            <label for="register-code" v-show="signUpData.type == '1'">{{phrases.signup_identitycode}}</label>
                            <input type="text" class="form-control" id="register-code" name="register-code"
                                   v-model="signUpData.code"
                                   :class="{'has-error' : signUpSettings.submitted && !signUpData.code.length}">
                        </div>
                        <div class="form-group">
                            <label for="register-mobile">{{phrases.signup_mobile}}</label>
                            <input type="email" class="form-control" id="register-mobile" name="register-mobile"
                                   v-on:keypress="allowNumbersOnly"
                                   v-model="signUpData.mobile"
                                   :class="{'has-error' : signUpSettings.submitted && !signUpData.mobile.length}">
                        </div>
                        <div class="form-group" v-show="signUpData.type == '1'">
                            <label for="register-mobile">{{phrases.signup_watpayer}}</label>
                            <select class="form-control" v-model="signUpData.vatType"
                                    :class="{'has-error' : signUpSettings.submitted && !signUpData.vatType.length}">
                                <option></option>
                                <option value="0">{{phrases.signup_no}}</option>
                                <option value="1">{{phrases.signup_yes}}</option>
                            </select>
                        </div>
                        <div class="form-group">
                            <label for="register-password">{{phrases.signup_password}}</label>
                            <input type="password" class="form-control" id="register-password" name="register-password"
                                   v-model="signUpData.password"
                                   :class="{'has-error' : signUpSettings.submitted && !signUpData.password.length}">
                        </div>
                        <div class="form-group">
                            <label for="register-password">{{phrases.signup_repeatpassword}}</label>
                            <input type="password" class="form-control" id="register-password" name="register-password"
                                   v-model="signUpData.repeatPassword"
                                   :class="{'has-error' : signUpSettings.submitted && !signUpData.repeatPassword.length}">
                        </div>
                        <div class="alert alert-danger" v-show="signUpSettings.succeeded == false">
                            {{signUpSettings.resultMessage}}
                        </div>
                        <div class="form-footer">
                            <button type="submit" class="btn btn-outline-primary-2 case-on"
                                    @click.prevent="signUp()">
                                <span v-show="!signUpSettings.sendingData">{{phrases.signup_signupbuttontitle}}</span>
                                <span v-show="signUpSettings.sendingData">{{phrases.signup_wait}}</span>
                                <i class="icon-long-arrow-right"></i>
                            </button>
                            <div class="custom-control custom-checkbox">
                                <input type="checkbox" class="custom-control-input" id="register-policy-2" required>
                                <label class="custom-control-label" for="register-policy-2">{{phrases.signup_agree}} <a href="" @click.prevent="openTermsUrl()" target="_blank">{{phrases.signup_rules}}</a></label>
                            </div>
                        </div>
                    </div>
                </div><!-- .End .tab-pane -->
            </div><!-- End .tab-content -->
        </div><!-- End .form-tab -->
    </div><!-- End .form-box -->
`
});
Vue.component('svg-icon', {
        props: ['icon'],
        data: function () {
            return {
                baseUrl: window._data.baseUrl
            };
        },
        methods: {
            getIconUrl: function () {
                return this.baseUrl + 'm/i/icons.svg#' + this.icon;
            }
        },
        mounted() {
        }
    ,
template: `
    <svg v-once><use v-bind="{\'xlink:href\' : getIconUrl()}" /></svg>
`
});
(function (target) {

    target._app = new Vue({
        el: "#vueapp"
    });
})(window);